var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-client-table',{attrs:{"data":_vm.lignes,"columns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"libelle",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.libelle)+" ")]}},{key:"produit",fn:function(ref){
var row = ref.row;
return [_c('router-link-blank',{attrs:{"to":{ name: 'c.bodac.catalogue-impressionAffiche', params: { id: row.produitId }},"message":row.produit.libelle}})]}},{key:"lieuDeLivraison",fn:function(ref){
var row = ref.row;
return [(row.lieuDeLivraisonId)?_c('router-link-blank',{attrs:{"to":{ name: 'c.achat.fournisseurs', params: { id: row.lieuDeLivraisonId }},"message":row.lieuDeLivraison.nomCommercial}}):_vm._e()]}},{key:"quantite",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"is-pulled-right"},[_vm._v(" "+_vm._s(row.quantite)+" ")])]}},{key:"quantiteRapproche",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"is-pulled-right"},[_vm._v(" "+_vm._s(_vm.getQuantiteRapproche(row))+" ")])]}},{key:"quantiteResteARapprocher",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"is-pulled-right"},[_vm._v(" "+_vm._s(row.quantiteResteARapprocher)+" ")])]}},{key:"etatRapprochement",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.getEtatLibelle(row.etatRapprochement))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }